export const getDollarQuote = (order) => {
  if (order.dollarQuotation && order.dollarQuotationType) {
    return Number(order.dollarQuotation[order.dollarQuotationType]);
  }

  return Number(order.dollarQuote);
};
